import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  compose,
  withHandlers,
  withState,
  withStateHandlers,
} from 'recompose';
import { find, reject } from 'lodash';
import { pipe } from 'ramda';

import { createPaymentCard } from '../../../payment/actions';
import PaymentOptionsModal from '../components/PaymentOptionsModal';
import { getBarberUserId, getShop } from '../../../../auth/selectors';
import { replaceItemInCollection } from '../../../../common/helpers/functional';
import { withPaymentInfoSetupStatus } from '../../../../common/hoc/paymentInfoSetupStatus';

const paymentCards = withStateHandlers(
  () => ({
    cards: [],
  }),
  {
    setCards: () => cards => ({ cards }),
    removeCard: props => cardId => ({
      cards: reject(props.cards, { id: cardId }),
    }),

    appendCard: props => card => ({
      cards: [...props.cards, card],
    }),

    updateDefaultCard: props => (card) => {
      const defaultCard = {
        ...find(props.cards, { isDefault: true }),
        isDefault: false,
      };
      const cards = pipe(
        replaceItemInCollection(defaultCard),
        replaceItemInCollection(card),
      )(props.cards);
      return { cards };
    },
  }
);

const PaymentOptionsContainer = compose(
  withRouter,
  paymentCards,
  withState('fetching', 'setFetching', false),
  connect(
    (state, ownProps) => ({
      customerId: ownProps.customerId || ownProps.params.customerId,
      shopId: getShop(state),
      barberId: getBarberUserId(state),
    }),
    { createPaymentCard }
  ),
  withHandlers({
    addCard: props => token => props.createPaymentCard(
      props.customerId,
      token,
      { shopId: props.shopId, barberId: props.barberId }
    ).then((response) => {
      props.appendCard(response);
      return Promise.resolve();
    }),
  }),
  withPaymentInfoSetupStatus,
)(PaymentOptionsModal);

export default PaymentOptionsContainer;
